import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Breadcrumb } from '../interfaces';
import {
  BreadcrumbToolbar,
  ConnectedLeftNavToolbar,
  ConnectedMainToolbar,
  HcpSessionManager,
  SubToolbar,
  Footer
} from '.';
import { scrollToTop } from '../utils';
import { useSelector } from 'react-redux';
import { AppRootState, AuthState } from '../redux';

interface PrivateLayoutProps extends React.PropsWithChildren<unknown> {
  className?: string;
  breadcrumbs?: Breadcrumb[];
  fullWidth?: boolean;
  pageTitle?: string;
  pageIcon?: React.ReactNode;
  subtoolbarChildren?: React.ReactNode;
  disableViewContainer?: boolean;
  contentKey?: string;
  hideLeftNav?: boolean;
  pageTitleClassName?: string;
}

export const PrivateLayout = ({
  breadcrumbs,
  children,
  className,
  fullWidth,
  pageTitle,
  pageIcon,
  subtoolbarChildren,
  disableViewContainer,
  contentKey,
  hideLeftNav,
  pageTitleClassName
}: PrivateLayoutProps) => {
  useEffect(scrollToTop, []);

  const WrapperComponent = fullWidth ? 'div' : Container;
  const wrapperClassName = fullWidth ? 'px-4' : '';
  const auth: AuthState = useSelector((state: AppRootState) => state.auth);
  const isAuthenticated = auth.session?.user;
  return (
    <>
      <div className='main-container'>
        <div className='content'>
          <div
            className='parent-container'
            style={isAuthenticated ? { width: '99%', height: '100%' } : { width: '100%' }}>
            <ConnectedMainToolbar />
            <Row className='sidebar-container' style={{ display: 'flex' }}>
              {!hideLeftNav && (
                <Col sm={2} style={{ paddingRight: 'unset' }}>
                  <ConnectedLeftNavToolbar />
                </Col>
              )}

              <Col
                sm={!hideLeftNav ? 10 : 12}
                style={{ paddingLeft: !hideLeftNav ? 'unset' : '15px', paddingRight: !hideLeftNav ? 'unset' : '15px' }}>
                {breadcrumbs && <BreadcrumbToolbar breadcrumbs={breadcrumbs} />}
                {!disableViewContainer && (
                  <SubToolbar
                    pageTitle={pageTitle}
                    pageIcon={pageIcon}
                    contentKey={contentKey}
                    pageTitleClassName={pageTitleClassName}>
                    {subtoolbarChildren}
                  </SubToolbar>
                )}
                {!disableViewContainer && (
                  <WrapperComponent
                    className={`content-details view-container container-sr ${wrapperClassName} ${
                      className ?? ''
                    }`.trim()}>
                    <HcpSessionManager />
                    {children}
                  </WrapperComponent>
                )}
                {disableViewContainer && (
                  <div className='content-details'>
                    <HcpSessionManager />
                    {children}
                  </div>
                )}
                {isAuthenticated && <Footer />}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};
